"use client";

import { useCallback, useState } from "react";

import type { SEOIntentConfig } from "@/lib/seo-intents";
import KundaliFormCard from "../_home/KundaliFormCard";
import TopicSelect from "./TopicSelect";

type SeoEntry = { config: SEOIntentConfig; sourcePath: string };

export default function AIAstrologerConsultationIsland() {
  const [seoEntry, setSeoEntry] = useState<SeoEntry | null>(null);
  const handleIntentCaptured = useCallback((entry: SeoEntry) => {
    setSeoEntry(entry);
  }, []);

  return (
    <>
      <div className="mx-auto max-w-md">
        <TopicSelect onIntentCaptured={handleIntentCaptured} />
      </div>
      <KundaliFormCard
        source="ai_astrologer"
        submitLabel="Generate chart and start chat"
        loadingLabel="Opening your AI Jyotish chat..."
        loadingLabelHi="AI Jyotish chat khul raha hai..."
        reassuranceNote="Free chat - no signup needed. Birth time is optional; exact time improves Lagna and house detail."
        reassuranceNoteHi="Free chat - signup nahi chahiye. Birth time optional hai; exact time Lagna aur house detail improve karta hai."
        savedNote="Used only to calculate and save your reading for this chat."
        showDailyInsightCard={false}
        containerClassName="mx-auto max-w-md"
        placePlaceholder="City or birth place"
        seoEntryOverride={seoEntry}
      />
    </>
  );
}
